const apiUrl = process.env.REACT_APP_API_URL;

export const PostCazaStart = async (idCaza: string, userId: string, idConjunt?: number | null) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/caza/${idCaza}/start`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ id: userId, idConjunt: idConjunt ?? null })
            });
        return response.ok;
    } catch (error) {
        console.log('Error al iniciar la caza:', error);
        return false;
    }
};
